<template>
	<div class="modal" tabindex="-1" id="modalForm" ref="modalForm">
		<div class="modal-dialog">
			<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title">{{tarif.full_name}}</h5>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
			</div>
			<div class="modal-body">
				<div v-if="send == false">
					<p>Заполните форму и дождитесь звонка специалиста</p>
					<form action="" class="needs-validation" :class="{'was-validated': triedSend}">
						<div class="mb-3">
							<label for="city">Населенный пункт</label>
							<input type="text" class="form-control" id="city" v-model="city" required>
							<div class="invalid-feedback">
								Заполните город
							</div>
						</div>
						<div class="mb-3">
							<label for="address">Адрес</label>
							<input type="text" class="form-control" id="address" v-model="address" placeholder="Улица, дом - квартира" required>
							<div class="invalid-feedback">
								Заполните свой адрес, улица дом-квартира
							</div>
						</div>
						<div class="mb-3">
							<label for="name">Ваше имя</label>
							<input type="text" class="form-control" id="name" v-model="name" required>
							<div class="invalid-feedback">
								Введите как к Вам обращаться
							</div>
						</div>
						<div class="mb-3">
							<label for="phone">Контактный телефон</label>
							<input type="text" class="form-control" id="phone" v-model="phone" v-maska="'+7(###)###-##-##'" placeholder="+7(" required>
							<div class="invalid-feedback">
								Введите контактный телефон, чтобы мы могли с Вами связаться
							</div>
						</div>
					</form>
				</div>
				<div v-if="send == true">
					<h3 class="success" v-if="statusSend=='success'">Спасибо. Ваша заявка отправлена. После определения технической возможности с Вами свяжутся.</h3>
					<div class="success" v-if="statusSend=='error'">
						<h3>Ошибки:</h3>
						<ul>
							<li v-for="error of errors" :key="error">{{error}}</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary btn-round" data-bs-dismiss="modal">Закрыть</button>
				<button type="button" class="btn btn-success btn-round" v-if="send==false" @click="btnSendOrder">Подать заявку</button>
			</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "ModalForm",
	props: {
		active: Boolean,
		tarif: Object
	},
	data() {
		return {
			city: '',
			address: '',
			name: '',
			phone: '',
			errors: [],
			triedSend: false,
			send: false,
			statusSend: null
		}
	},
	watch: {
		active(curr) {
			if(curr == true) {
				this.modal.show();
				this.triedSend = false;
				this.send = false;
				this.statusSend = null;
			}
			console.log('### change active, curr is ', curr);
		}
	},
	mounted() {
		this.modal = new window.bootstrap.Modal(document.querySelector('#modalForm'));
		console.log(this.modal);
		document.querySelector('#modalForm').addEventListener('hidden.bs.modal', ()=> {
			console.log('we hide modal');
			this.$emit('close');
		});
	},
	beforeUnmount() {
		document.querySelector('#modalForm').removeEventListener('hidden.bs.modal');
	},
	methods: {
		btnSendOrder() {
			this.triedSend = true;
			if(this.checkForm()) {
				console.log('send form');
				const form1 = new FormData();
				form1.append('city', this.city);
				form1.append('address', this.address);
				form1.append('name', this.name);
				form1.append('phone', this.phone);
				form1.append('referrer', document.referrer);
				form1.append('tarif', this.tarif.full_name);

				const url = '/send_next.php';
				fetch(url, {
					method: "POST",
					body: form1
				}).then(result => {
					console.log(result);
					if(result.status == 200) {
						const res = result.json();
						this.send = true;

						res.then(json => {
							this.statusSend = 'success';
							console.log(json);
						}).catch(err => {
							this.statusSend = 'error';
							console.log(err);
						})

						console.log(res);
						if(res.status == 1) {
							this.statusSend = 'success';
							console.log(res);
						} else {
							this.statusSend = 'error';
						}
					} else {
						this.message = 'Проблема с передачей данных. Попробуйте повторить заявку позже';
						this.send = true;
						this.statusSend = 'error';
					}
				}).catch(err => {
					console.log(err);
				});

			} else {
				console.log('do not send form');
				console.log(this.errors);
			}
		},
		checkPhone() {
			return /^\+7\(\d{3}\)\d{3}-\d{2}-\d{2}$/.test(this.phone) ? true : false;
		},
		checkForm() {
			this.errors = [];
			if(!this.checkPhone()) this.errors.push('Неправильно введен телефон');
			if(this.city.trim() == '') this.errors.push('Введите город');
			if(this.address.trim() == '') this.errors.push('Введите адрес');
			if(this.name.trim() == '') this.errors.push('Введите Ваше имя');
			if(this.phone.trim() == '') this.errors.push('Введите контактный телефон');
			if(this.errors.length == 0) return true;
			else return false;
		}
	}
}
</script>